module.exports = __webpack_public_path__ + "static/img/title_2.7a0c795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/title_2.png
// module id = eyuQ
// module chunks = 1